import * as React from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import axios from "axios";
import { useQueryClient } from "@tanstack/react-query";
import { DEFAULTS_BASE_URL, API_KEY } from "../../utils";
const fetchContactData = (props: any) => {
  const { cognitoIdToken } = props;
  axios.defaults.baseURL = DEFAULTS_BASE_URL;

  const headers = {
    "x-api-key": API_KEY,
    "Content-type": "text/plain",
  };
  const params = JSON.stringify(props);
  return axios.post(
    `${DEFAULTS_BASE_URL}/contact`,
    { text: params.toString() },
    { headers: headers }
  );
};

export const useContactData = (onSuccess: any, onError: any, props: any) => {
  const { cognitoIdToken } = props;
  const queryClient = useQueryClient();
  return useQuery(["contact", cognitoIdToken], () => fetchContactData(props), {
    onSuccess,
    onError,
  });
};

const fetchAddContactData = (props: any) => {
  const { cognitoIdToken, params } = props;
  axios.defaults.baseURL = DEFAULTS_BASE_URL;
  const headers = {
    "x-api-key": API_KEY,
    "Content-type": "text/plain",
  };
  // console.log(JSON.stringify(props));
  return axios.post(
    `${DEFAULTS_BASE_URL}/contact`,
    { text: params.toString() },
    { headers: headers }
  );
};

export const useAddContactData = (props: any) => {
  const { cognitoIdToken, params } = props;
  const queryClient = useQueryClient();
  return useMutation(fetchAddContactData, {
    onSuccess: () => {
      queryClient.invalidateQueries(["contacts", cognitoIdToken]);
      queryClient.invalidateQueries(["contact"]);
    },
  });
};
